import { route } from 'preact-router';
import { useEffect } from 'preact/hooks';
import { writeHostFilter } from '../../services/hostFilter.js';

/**
 * 343 (#937): `/h/<name>`, a host's share link. Public on purpose: it keeps the name on the device BEFORE any login, then
 * opens the search, which sits behind the login and the campus chooser as usual and reads the name from there. A
 * malformed name keeps nothing; the customer still lands on the search.
 */
export function HostLinkPage({ name }: { name?: string; path?: string }) {
  useEffect(() => {
    if (name) writeHostFilter(name);
    route('/search', true);
  }, [name]);
  return null;
}
